

export const listIndexesAndListFieldsRedux = (
  actionType: string,
) => {
    window.parent.primingcloudRedux.readings.listIndexesAndListFields(
      actionType,
    )
}

export const loadReadingMetadataRedux = (
  thingId: number,
  parameterId: number,
  actionType: string,
) => {
    window.parent.primingcloudRedux.readings.loadReadingMetadata(
      thingId,
      parameterId,
      actionType,
    )
}

export const loadReadingMetadataDetailsRedux = (
  thingId: number,
  parameterId: number,
  actionType: string
) => {
    window.parent.primingcloudRedux.readings.loadReadingMetadataDetails(
      thingId,
      parameterId,
      actionType,
    )
}

export const loadReadingsAtTimestampRedux = (
  ts: number,
  ou: number,
  parameterArray: number[],
  thingArray: number[],
  filterContextValue: string,
  actionType: string
) => {
    window.parent.primingcloudRedux.readings.loadReadingsAtTimestamp(
      ts,
      ou,
      parameterArray,
      thingArray,
      filterContextValue,
      actionType
    )
}

export const loadReadingsRedux = (
  start: number,
  end: number,
  ou: number,
  parameter: number,
  thingId: number,
  ascending: boolean,
  limit: number,
  actionType: string
) => {
    window.parent.primingcloudRedux.readings.loadReadings(
      start,
      end,
      ou,
      parameter,
      thingId,
      ascending,
      limit,
      actionType
    )
}

export const deleteReadingsRedux = (
  startTS: number,
  endTS: number,
  parameter: number,
  thing: number,
  actionType: string 
) => {
    window.parent.primingcloudRedux.readings.deleteReadings(
      startTS,
      endTS,
      parameter,
      thing,
      actionType
    )
}
